export default function Dashboard(){
  return(
    <div>
      Manage Variables (in either template or document views) coming soon! 
    </div>
  );
}